<template>
	<div>
		<div class="" style="display: flex;margin: 20px 0;">
			<span style="line-height: 32px">项目名称:</span>
			<el-input v-model="select.selectName" :clearable="true" @clear="getApplication" placeholder="请输入项目名称"
				style="margin-left: 10px;width: 200px;"></el-input>
			<el-button type="primary" style="margin-left: 20px" @click="searchData">
				查询
			</el-button>
		</div>
		<!-- 表格 -->
		<normalTable v-loading="loading" :tabList="tabList" :tableList="tableList" @copol-click="reciveClick">
		</normalTable>
		<div style="margin-top: 50px;" v-if="totalNum>10">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background>
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		getAppliInfo,
		getProjectType,
		saveQaCode,
		getQCteamCan
	} from '../../api/moudles/application.js'

	import normalTable from '../../components/table/normalTable.vue'

	export default {
		data() {
			return {
				canApllylist: [],
				select: {
					options1: [],
					options2: [],
					selectName: '',
					selectValue1: '',
					selectValue2: ''
				},
				loading: false,
				tabList: ['项目名称', '申请时间', '名额', '已申报', '状态', '动作'],
				tabList2: ['项目名称', '申报时间', '已申报', '动作'],
				tableList: [],
				tabCodeList: [],
				modelList: [],
				applyList: [],
				project_type: [],

				authCodeList: [],
				// 分页
				currentPage: 1,
				pageSize: 10,
				totalNum: 0,
				dialogFormVisible: false,
				isRegister: localStorage.getItem('isRegister')
			}
		},
		components: {
			normalTable
		},
		created() {
			this.getApplication()
			this.getProjecttype()
		},
		methods: {
			// 获取下拉选项
			async getProjecttype() {
				await getProjectType({
					data: {},
					success: res => {
						// console.log(res)
						const typeAll = res.data.typeAll
						const statusAll = res.data.statusAll
						const newtypeAll = []
						const newStatusAll = []
						Object.keys(typeAll).forEach((item, index) => {
							const newList = {}
							newList.text = typeAll[item]
							newtypeAll.push(newList)
						})
						statusAll.forEach((item, index) => {
							const newList = {}
							newList.text = item
							newStatusAll.push(newList)
						})
						this.select.options1 = newtypeAll
						this.select.options2 = newStatusAll
					}
				})
			},
			searchData() {
				this.getApplication()
			},
			close() {
				this.dialogFormVisible = false
			},
			// 分页
			handleSizeChange(val) {
				this.pageSize = val
				this.getApplication()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getApplication()
			},
			async getApplication() {
				let projectType = localStorage.getItem('projectType')
				const params = {
					name: this.select.selectName,
					project_type: 10,
					status: this.select.selectValue2,
					page: this.currentPage,
					limit: this.pageSize
				}
				if (localStorage.getItem('isRegister') == 1) {
					this.tabList = this.tabList2
				}
				this.loading = true
				await getAppliInfo({
					data: params,
					success: (res) => {
						console.log(res)
						this.totalNum = res.totalCount
						let dataList = res.data;
						// 类型列表
						let project_type = []
						// code列表
						let upCode = []
						// 模板列表
						let modelList = []
						// 是否过期
						let applyList = []
						let upList = []
						let idList = []
						let authCodeLists = []
						dataList.forEach((item) => {
							let newlist = {}
							//newlist['project_type_name'] = item.project_type_name
							newlist['project_name'] = item.project_name
							newlist['apply_time'] = item.apply_time
							// newlist['can_app_num'] = item.can_app_num
							/*if (localStorage.getItem('isRegister') != 1) {
								newlist['app_time'] = item.app_time
							}*/
							if (localStorage.getItem('isRegister') != 1) {
								newlist['distribution_count'] = item.enp.distribution_count
							}
							newlist['collect_count'] = item.enp.collect_count
							if (localStorage.getItem('isRegister') != 1) {
								newlist['status_name'] = item.enp.status_name
							}
							// 二级管理员 能查看
							if (localStorage.getItem('isRegister') != 1) {
								if (item.has_submit_app === 1) {
									newlist['soqcol'] = ['查看明细']
								} else {
									newlist['soqcol'] = ['申报']
								}
							} else {
								if (item.has_submit_app === 1) {
									newlist['soqcol'] = ['查看明细']
								} else {
									if (item.can_do_app == 1) {
										newlist['soqcol'] = ['开始申报', '查看明细']
									} else {
										newlist['soqcol'] = ['查看明细']
									}
								}
							}

							authCodeLists.push(item.auth_code)
							upCode.push(item.project_code)
							upList.push(newlist)
							idList.push(item.projectApplicationId)
							applyList.push(item.can_do_app)
							project_type.push(item.project_type)
							modelList.push(item.distribution_materials)
							if (item.non_member_can_apply) {
								this.canApllylist.push(item.non_member_can_apply)
							}
						})
						this.modelList = modelList
						this.tabCodeList = upCode
						this.applyList = applyList
						this.tableList = upList
						this.idList = idList
						this.authCodeList = authCodeLists
						this.project_type = project_type
						this.loading = false
					}
				})
			},

			// 接受子组件事件
			async reciveClick(e) {
				const {
					key,
					list
				} = e
				this.tabCodeList[key]
				if (list === '查看明细') {
					// 浙江优秀项目经理
					this.$router.push('/contribute')
				} else {
					if (this.applyList[key] !== 1) {
						this.$message.error('已经过了申报时间，无法申报')
						return
					}
					// 浙江优秀项目经理
					this.$router.push({
						name: 'zjManager',
						params: {
							type: 10,
							isAdd: 1,
							projectCode: this.tabCodeList[key],
						}
					})
				}
			}
		}
	}
</script>

<style scoped="scoped">

</style>
